module.exports = __webpack_public_path__ + "static/chart-return-to-stock-1d290d97d1ef0f5fc17056cb6f89917f.svg";